import {Tracks as module} from '../actions/index';
const {actiontypes} = module;


const initialState = {
  tracks: []
}


function injectTrack(track, tracks) {
  let tmp = [...tracks];
  tmp.splice(tmp.map(e => e._id).indexOf(track._id), 1, track)
  return tmp;
}
function deleteTrack(track, tracks) {
  let tmp = [...tracks];
  tmp.splice(tmp.map(e => e._id).indexOf(track._id), 1)
  return tmp;
}

function sortTracks(tracks, direction = -1) {
  let d = direction > 0 ? 1 : -1;
  return tracks.sort((a, b) => {
    if (!a.releaseDate) return -1*d;
    return (a.releaseDate > b.releaseDate) ? 1*d :
    ((b.releaseDate > a.releaseDate) ? -1*d : 0);
  });
}







export default function tracks(state = initialState, action) {

  switch(action.type) {
    case actiontypes.TRACK_CREATE_SUCCESS:
      return {...state,
        tracks: [{...action.track}, ...state.tracks]
      };


    case actiontypes.TRACK_UPDATE_SUCCESS:
      return {...state,
        tracks: injectTrack(action.track, state.tracks)
      };


    case actiontypes.TRACK_GETALL_SUCCESS:
      return {...state,
        tracks: [...action.tracks]
      };


    case actiontypes.TRACK_DELETE_SUCCESS:
      return {...state,
        tracks: deleteTrack(action.track, state.tracks)
      };



    case actiontypes.TRACK_ARTWORK_UPLOAD_SUCCESS:
      return {...state,
        tracks: injectTrack({...action.track, _imgDummy: Math.random()}, state.tracks)
      };
    case actiontypes.TRACK_ARTWORK_DELETE_SUCCESS:
      return {...state,
        tracks: injectTrack(action.track, state.tracks)
      };
    default:
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/tracks.js